import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { DescLanguageDto } from "src/dtos/descLanguage/descLanguageDto";
import { getData } from "src/utils/axios/serverHelper";

const descLanguageUrl = `${config.apiUrl}/descLanguage`;

export const getDescLanguageList = async (searchText: string = '', workplaceCd: string = '', itemCd: string = '') => {

	const url = `${descLanguageUrl}`;

	return await getData<ResponseDto<DescLanguageDto[]>>(url, {
		params: { searchText, workplaceCd, itemCd },
	});
}